import { render, staticRenderFns } from "./braze-bell-icon.vue?vue&type=template&id=16a9df49&"
import script from "./braze-bell-icon.vue?vue&type=script&lang=js&"
export * from "./braze-bell-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports